/* eslint-disable*/
import VueStoreService from './VueStoreService';
const StockService = {
    async getMovements(url,store){
        var resp = await VueStoreService.get("api/stock/searchStockperStore"+url, store)
        return resp;
    },
    async getListMovements(store){
        var resp = await VueStoreService.get("api/stock", store)
        return resp;
    },
    async saveStock(stock_id,data,store){
        var resp = await VueStoreService.patch("api/stock/"+stock_id,data, store)
        return resp;
    },
}

export default StockService;